// import React, { useState, useEffect } from "react";

// const TrustedClients = () => {
//   const clients = [
//     {
//       name: "Averti Organisation",
//       logo: "./assets/images/trustedClient/averti.png",
//     },
//     {
//       name: "Women to Women TV",
//       logo: "./assets/images/trustedClient/w2w.png",
//     },
//     {
//       name: "TrueGrit",
//       logo: "./assets/images/trustedClient/flower.png",
//     },
//     {
//       name: "Village Veritable Foods",
//       logo: "./assets/images/trustedClient/vvfoods.png",
//     },
//     {
//       name: "E&J International Art Gallery",
//       logo: "./assets/images/trustedClient/EjArt.jpeg",
//     },
//     {
//       name: "WDT Energy",
//       logo: "./assets/images/trustedClient/wdt.png",
//     },
//     {
//       name: "Bousow",
//       logo: "./assets/images/trustedClient/bousow.png",
//     },
//     {
//       name: "Jewelivery",
//       logo: "./assets/images/trustedClient/jewelivery.png",
//     },
//     {
//       name: "Jean Gillies Capital",
//       logo: "./assets/images/trustedClient/gean.png",
//     },
//     {
//       name: "Raur Tea",
//       logo: "./assets/images/trustedClient/raurTea.png",
//     },
//     {
//       name: "Translytor",
//       logo: "./assets/images/trustedClient/translytor.png",
//     },
//     {
//       name: "Allure Global",
//       logo: "./assets/images/trustedClient/allureGlobal.jpg",
//     },
//     {
//       name: "company",
//       logo: "./assets/images/trustedClient/armForces.webp",
//     },
//     {
//       name: "Bluepay Card",
//       logo: "./assets/images/trustedClient/bluePay.png",
//     },
//   ];

//   const testimonials = [
//     {
//       name: "Soul Goodman",
//       position: "CEO and Founder",
//       avatar: "../assets/images/testimonials/testimonials-1.jpg",
//       rating: "4.5",
//      rating_image:"../assets/images/homeImages/4.png",
//       feedback:
//         "I just engaged VoIP Services Provider Development to create a unique VoIP solution for my company, and I have been nothing but satisfied. The crew was exceptionally educated and accommodating throughout the entire process. They were able to give me with an efficient solution that satisfied all of my criteria in a timely manner. I strongly suggest Voip Development for any of your VoIP requirements.",
//     },
//     {
//       name: "Sara Willson",
//       position: "Designer",
//       avatar: "../assets/images/testimonials/testimonials-2.jpg",
//       rating: "5",
//      rating_image:"../assets/images/homeImages/5.png",
//       feedback:
//         "I recently had my website developed, and I am really delighted with the results. The team was able to design a wonderful website that was just what I had envisioned. They were incredibly educated about website creation and were able to rapidly and efficiently implement my idea.",
//     },
//     {
//       name: "Jena Karlis",
//       position: "Store Owner",
//       rating: "4.1",
//       avatar: "../assets/images/testimonials/testimonials-3.jpg",
//       rating_image:"../assets/images/homeImages/4.png",
//       feedback:
//         "My website was recently redone, and I couldn't be happier with the outcome. The crew that built the website was competent and educated, and they knew exactly what I wanted to accomplish with it. They succeeded in producing a responsive, modern design that will appeal to more clients. The creation of the website much exceeded my expectations in every aspect",
//     },
//     {
//       name: "Matt Brandon",
//       position: "Freelancer",
//       rating: "4.8",
//      rating_image:"../assets/images/homeImages/5.png",
//       avatar: "../assets/images/testimonials/testimonials-4.jpg",
//       feedback:
//         "My team and I have been able to keep in sync because to Ayanshtech solutions. Before, we had a wide range of opinions. Our time and money have both been saved by using ayanshtech solutions",
//     },
//     {
//       name: "John Larson",
//       position: "Entrepreneur",
//       rating: "4.2",
//       rating_image:"../assets/images/homeImages/4.png",
//       avatar: "../assets/images/testimonials/testimonials-5.jpg",
//       feedback:
//         "I have been using Ayanshtech solutions for over a year now and I absolutely love them. Without it, I can't imagine life. Customer support is excellent, and it's fairly simple to use.",
//     },
//   ];

//   const [currentTestimonial, setCurrentTestimonial] = useState(0);

//   useEffect(() => {
//     const intervalId = setInterval(() => {
//       setCurrentTestimonial(
//         (prevTestimonial) => (prevTestimonial + 1) % testimonials.length
//       );
//     }, 3000);

//     return () => clearInterval(intervalId);
//   }, [testimonials.length]);

//   const handleNext = () => {
//     setCurrentTestimonial(
//       (prevTestimonial) => (prevTestimonial + 1) % testimonials.length
//     );
//   };

//   const handlePrev = () => {
//     setCurrentTestimonial(
//       (prevTestimonial) =>
//         (prevTestimonial - 1 + testimonials.length) % testimonials.length
//     );
//   };

//   return (
//     <div className=" flex flex-col justify-center items-center text-center p-6">
//       <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-2">
//         Globally Trusted Clients
//       </h3>
//       <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 px-6 max-w-4xl">
//         Committed to delivering best-in-class services with proven project
//         management practices.
//       </p>

//       <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-12 px-6 py-12 max-w-7xl">
//         {/* Mapping through clients and displaying logos */}
//         {clients.map((client, index) => (
//           <div key={index} className="flex justify-center items-center">
//             <img
//               src={client.logo}
//               alt={client.name}
//               className="w-36 h-36 object-contain hover:opacity-75 transition-opacity duration-300"
//             />
//           </div>
//         ))}
//       </div>

//       <div className=" w-full">
//         <div className="max-w-6xl mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
//             {/* Left Side: Text Section */}
//             <div className="text-left">
//               <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-8 text-gray-800">
//                 Hear From Our Happy Clients!
//               </h3>
//               <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mb-12">
//                 Discover how our innovative solutions have empowered businesses
//                 to achieve remarkable success and global reach.
//               </p>
//             </div>

//             {/* Right Side: Testimonial Section */}
//             <div
//               className="relative  p-8 rounded-md shadow-md max-w-lg mx-auto min-h-[300px]"
//               style={{
//                 boxShadow:
//                   "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
//               }}
//             >
//               <div className="flex items-center justify-between  mb-4">
//                 <div className="flex items-center ">
//                   <img
//                     className="w-24 h-24 rounded-full mr-4"
//                     src={testimonials[currentTestimonial].avatar}
//                     alt="Avatar"
//                   />
//                   <div>
//                     <h4 className="sm:text-base md:text-lg lg:text-xl font-bold text-gray-800">
//                       {testimonials[currentTestimonial].name}
//                     </h4>
//                     <p className="sm:text-base md:text-lg lg:text-xl text-gray-600">
//                       {testimonials[currentTestimonial].position}
//                     </p>
//                   </div>
//                 </div>
//                 <div className="flex items-center g-1">
//                   <p className="sm:text-base md:text-lg lg:text-xl text-gray-600">
//                     {testimonials[currentTestimonial].rating}
//                   </p>
//                   <img
//                     className="w-6 h-6"
//                     src={testimonials[currentTestimonial].rating_image}
//                     alt="rating"
//                   />
//                 </div>
//               </div>
//               <div
//                 className="sm:text-base md:text-lg lg:text-xl text-gray-600 mb-4 overflow-hidden"
//                 style={{
//                   height: "6rem",
//                   lineHeight: "1.5rem",
//                 }}
//               >
//                 {testimonials[currentTestimonial].feedback}
//               </div>
//               <a
//                 href="#"
//                 className="sm:text-base md:text-lg lg:text-xl text-blue-500 font-bold"
//               >
//                 {testimonials[currentTestimonial].company}
//               </a>

//               {/* Prev/Next buttons */}
//               <button
//                 onClick={handlePrev}
//                 className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-200 hover:bg-blue-600  p-2 rounded-full shadow-md"
//               >
//                 &#8249;
//               </button>

//               <button
//                 onClick={handleNext}
//                 className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-200 hover:bg-blue-600 p-2 rounded-full shadow-md"
//               >
//                 &#8250;
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TrustedClients;

import React, { useState, useEffect, useRef } from "react";

const TrustedClients = () => {
  const clients = [
    {
      name: "Averti Organisation",
      logo: "./assets/images/trustedClient/averti.png",
    },
    {
      name: "Women to Women TV",
      logo: "./assets/images/trustedClient/w2w.png",
    },
    {
      name: "TrueGrit",
      logo: "./assets/images/trustedClient/flower.png",
    },
    {
      name: "Village Veritable Foods",
      logo: "./assets/images/trustedClient/vvfoods.png",
    },
    {
      name: "E&J International Art Gallery",
      logo: "./assets/images/trustedClient/EjArt.jpeg",
    },
    {
      name: "WDT Energy",
      logo: "./assets/images/trustedClient/wdt.png",
    },
    {
      name: "Bousow",
      logo: "./assets/images/trustedClient/bousow.png",
    },
    {
      name: "Jewelivery",
      logo: "./assets/images/trustedClient/jewelivery.png",
    },
    {
      name: "Jean Gillies Capital",
      logo: "./assets/images/trustedClient/gean.png",
    },
    {
      name: "Raur Tea",
      logo: "./assets/images/trustedClient/raurTea.png",
    },
    {
      name: "Translytor",
      logo: "./assets/images/trustedClient/translytor.png",
    },
    {
      name: "Allure Global",
      logo: "./assets/images/trustedClient/allureGlobal.jpg",
    },
    {
      name: "company",
      logo: "./assets/images/trustedClient/armForces.webp",
    },
    {
      name: "Bluepay Card",
      logo: "./assets/images/trustedClient/bluePay.png",
    },
  ];

  const testimonials = [
    {
      avatar: "../assets/images/homeImages/rating-1.webp",
      link:"https://review.clutch.co/review?provider_id=9d50c0e8-5c90-4980-8cc1-b1bb862720d9",
    },
    {
      avatar: "../assets/images/homeImages/rating-2.webp",
      link:"https://review.clutch.co/review?provider_id=9d50c0e8-5c90-4980-8cc1-b1bb862720d9",

    },
    {
      avatar: "../assets/images/homeImages/rating-3.webp",
      link:"https://share.google/olD68CxmLzFPKOsKs",

    },
    {
      avatar: "../assets/images/homeImages/rating-4.webp",
      link:"https://review.clutch.co/review?provider_id=9d50c0e8-5c90-4980-8cc1-b1bb862720d9",

    },
    {
      avatar: "../assets/images/homeImages/rating-3.webp",
      link:"https://share.google/olD68CxmLzFPKOsKs",

    },

  ];

  const visibleCount = 4;
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  // Auto Slide
  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setIndex((prev) =>
        prev >= testimonials.length - visibleCount ? 0 : prev + 1
      );
    }, 2000); // 2 sec
  };

  const stopAutoSlide = () => clearInterval(intervalRef.current);

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  const visibleItems = testimonials.slice(index, index + visibleCount);


  return (
    <div className=" flex flex-col justify-center items-center text-center p-6">
      <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-2">
        Globally Trusted Clients
      </h3>
      <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 px-6 max-w-4xl">
        Committed to delivering best-in-class services with proven project
        management practices.
      </p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-12 px-6 py-12 max-w-7xl">
        {/* Mapping through clients and displaying logos */}
        {clients.map((client, index) => (
          <div key={index} className="flex justify-center items-center">
            <img
              src={client.logo}
              alt={client.name}
              className="w-36 h-36 object-contain hover:opacity-75 transition-opacity duration-300"
            />
          </div>
        ))}
      </div>

      <div className=" w-full">
        <div className="max-w-7xl mx-auto px-4">
          <div className=" md:grid-cols-2 gap-8 items-center">
            {/* Left Side: Text Section */}
            <div className="text-center">
              <h3 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-8 text-gray-800">
                Hear From Our Happy Clients!
              </h3>
              <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 mb-12">
                Discover how our innovative solutions have empowered businesses
                to achieve remarkable success and global reach.
              </p>
            </div>

            {/* Right Side: Testimonial Section */}

            <div className="overflow-hidden group">
              <div className="flex gap-3 animate-slide group-hover:paused p-2">
                {[...testimonials, ...testimonials].map((t, i) => (

                  <div
                    key={i}
                  >
                    <div  className="w-[120px] sm:w-[150px] md:w-[180px] lg:w-[200px] h-[100px] 
                   flex-shrink-0 rounded-md shadow-md bg-green-900 overflow-hidden p-2">
                    <a
                     
                      href={t.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={t.avatar}
                        alt=""
                        className="w-full h-full object-contain"
                      />
                    </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustedClients;

